// CloneSolutionModal.tsx
import React from "react";
import { Box, Button, Typography, TextField } from "@mui/material";
import { CustomModal } from "./CustomeModal";

interface CloneSolutionModalProps {
  open: boolean;
  onClose: () => void;
  cloneFormData: {
    cloneFromCohortId: string;
    cloneFromQuizId: string;
    cloneToCohortId: string;
    cloneToQuizId: string;
    teachUrl: string;
  };
  cloneFormErrors: {
    cloneFromCohortId: boolean;
    cloneFromQuizId: boolean;
    cloneToCohortId: boolean;
    cloneToQuizId: boolean;
    teachUrl: boolean;
  };
  onFormChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}

export const CloneSolutionModal: React.FC<CloneSolutionModalProps> = ({
  open,
  onClose,
  cloneFormData,
  cloneFormErrors,
  onFormChange,
  onSubmit,
  isSubmitting,
}) => {
  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title="Clone Autograder Solution"
    >
      <Typography variant="subtitle1" sx={{ mt: 2 }}>
        Clone From
      </Typography>
      <Box display="flex" gap={2}>
        <TextField
          label="Cohort ID"
          name="cloneFromCohortId"
          value={cloneFormData.cloneFromCohortId}
          onChange={onFormChange}
          fullWidth
          margin="normal"
          error={cloneFormErrors.cloneFromCohortId}
          helperText={
            cloneFormErrors.cloneFromCohortId && "Cohort ID is required"
          }
        />
        <TextField
          label="Quiz ID"
          name="cloneFromQuizId"
          value={cloneFormData.cloneFromQuizId}
          onChange={onFormChange}
          fullWidth
          margin="normal"
          error={cloneFormErrors.cloneFromQuizId}
          helperText={cloneFormErrors.cloneFromQuizId && "Quiz ID is required"}
        />
      </Box>
      <Typography variant="subtitle1" sx={{ mt: 2 }}>
        Clone To
      </Typography>
      <Box display="flex" gap={2}>
        <TextField
          label="Cohort ID"
          name="cloneToCohortId"
          value={cloneFormData.cloneToCohortId}
          onChange={onFormChange}
          fullWidth
          margin="normal"
          error={cloneFormErrors.cloneToCohortId}
          helperText={
            cloneFormErrors.cloneToCohortId && "Cohort ID is required"
          }
        />
        <TextField
          label="Quiz ID"
          name="cloneToQuizId"
          value={cloneFormData.cloneToQuizId}
          onChange={onFormChange}
          fullWidth
          margin="normal"
          error={cloneFormErrors.cloneToQuizId}
          helperText={cloneFormErrors.cloneToQuizId && "Quiz ID is required"}
        />
      </Box>
      <TextField
        label="Teach URL"
        name="teachUrl"
        value={cloneFormData.teachUrl}
        onChange={onFormChange}
        fullWidth
        margin="normal"
        error={cloneFormErrors.teachUrl}
        helperText={cloneFormErrors.teachUrl && "Teach URL is required"}
      />
      <Box justifyContent="flex-end" display="flex">
        <Button
          variant="outlined"
          color="primary"
          onClick={onSubmit}
          disabled={isSubmitting}
          sx={{ mt: 2 }}
        >
          {isSubmitting ? "Saving..." : "Submit"}
        </Button>
      </Box>
    </CustomModal>
  );
};
